import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=7a06ea1a&scoped=true"
import script from "./FooterNew.vue?vue&type=script&lang=ts"
export * from "./FooterNew.vue?vue&type=script&lang=ts"
import style0 from "./FooterNew.vue?vue&type=style&index=0&id=7a06ea1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a06ea1a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BackToTop: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/back-to-top.vue').default})
